import { r2Fetch } from './client';

export interface R2FileBulkContentParams {
  bucket_id: string;
  keys?: string[];
}

export interface R2FileBulkContentResponse {
  content: string;
  errors?: Array<{ key: string; error: string }>;
}

export async function r2FileBulkContent(
  params: R2FileBulkContentParams
): Promise<R2FileBulkContentResponse> {
  return r2Fetch<R2FileBulkContentResponse>('/rpc/r2_file_bulk_content', {
    body: params,
  });
}
